// @ts-nocheck
import React, { useState } from "react";
import { supabase } from "../../services/supabaseClient";
import { Link, useNavigate } from "react-router-dom";
import "./Auth.css";

const ResetPasswordPage = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const navigate = useNavigate();

  const handleSave = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    setIsSaving(true);

    if (newPassword !== confirmPassword) {
      setError("⚠️ Passwords do not match.");
      setIsSaving(false);
      return;
    }

    if (newPassword.length < 8) {
      setError("⚠️ Password must be at least 8 characters long.");
      setIsSaving(false);
      return;
    }

    const { error } = await supabase.auth.updateUser({ password: newPassword });

    if (error) {
      setError(error.message);
    } else {
      setMessage("✅ Password updated successfully. Redirecting to login...");
      setTimeout(() => navigate("/login"), 2000);
    }

    setIsSaving(false);
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Choose a New Password</h2>

        {message && <div className="success-message">{message}</div>}
        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSave}>
          <div className="form-group">
            <label htmlFor="newPassword">New Password</label>
            <input
              type="password"
              id="newPassword"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              placeholder="Enter new password"
            />
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Confirm New Password</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              placeholder="Re-enter new password"
            />
          </div>

          <button type="submit" className="auth-button" disabled={isSaving}>
            {isSaving ? "Saving..." : "Update Password"}
          </button>
        </form>

        <p className="auth-link">
          Back to <Link to="/login">Log in</Link>
        </p>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
